/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Italicize_Event_TextInputs */



/**
* | output |
* | --- |
* | "Italicize event text" |
*
* @param {Italicize_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const italicize_event_text = /** @type {((inputs?: Italicize_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Italicize_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte d'événement en italique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignistext kursiv darstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metti in corsivo il testo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выделить текст события курсивом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Poner en cursiva el texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件文本斜体化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストを斜体にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट को इटैलिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto do evento em itálico")
	return /** @type {LocalizedString} */ ("Italicize event text")
});